
export default interface XgsInlineSwitchState {
  activeInlineName: string;
};

export const initialXgsInlineSwitchState: XgsInlineSwitchState = {
  activeInlineName: ""
};
